import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { legalAPI } from '../utils/api';

export default function LegalDocumentPage({ type, fallbackTitle }) {
  const [searchParams] = useSearchParams();
  const [document, setDocument] = useState(null);
  const [state, setState] = useState('loading');

  useEffect(() => {
    const controller = new AbortController();
    legalAPI.get(type, searchParams.get('version'), { signal: controller.signal })
      .then(({ data }) => { setDocument(data.data); setState('ready'); })
      .catch((error) => { if (error.code !== 'ERR_CANCELED') setState('error'); });

    return () => controller.abort();
  }, [searchParams, type]);

  return <main className="min-h-screen bg-black px-4 pb-16 pt-24 text-white">
    <article className="mx-auto max-w-4xl rounded-xl border border-zinc-800 bg-zinc-900 p-6 sm:p-10">
      {state === 'loading' && <p role="status" className="text-gray-300">Loading {fallbackTitle}…</p>}
      {state === 'error' && <div role="alert" className="rounded border border-red-500 bg-red-950/40 p-4 text-red-200">The requested legal document is unavailable.</div>}
      {state === 'ready' && <>
        <h1 className="text-3xl font-bold sm:text-4xl">{document.title}</h1>
        <p className="mt-3 text-sm text-gray-400">Version {document.version} · Published {new Date(document.published_at).toLocaleDateString('en-IN')}</p>
        <div className="mt-8 whitespace-pre-wrap break-words text-gray-200">{document.content}</div>
      </>}
    </article>
  </main>;
}
